





























import mixins from 'vue-typed-mixins';
import SendEmailForm from '@/components/email/SendEmailForm.vue';
import EmailUtils, { AutomatedEmail } from '@/utils/EmailUtils';
export default mixins().extend({
  components: {
    SendEmailForm,
  },

  computed: {
    headers() {
      return [
        { text: this.$i18n.tc('model.common.key'), value: 'key' },
        { text: this.$i18n.tc('model.common.name'), value: 'name' },
        {
          text: this.$i18n.tc('model.automated.email.subject', 2),
          value: 'subject',
        },
        { text: this.$i18n.tc('model.common.type', 2), value: 'type' },
      ];
    },
  },

  data(): {
    items?: AutomatedEmail[];
  } {
    return {
      items: undefined,
    };
  },

  async mounted() {
    try {
      const resp = await Promise.all([EmailUtils.api.list()]);
      this.items = resp[0];
    } catch (error) {
      this.$alert.show('mounted', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  methods: {
    async create() {
      await this.$router.push({ name: 'email-create' });
    },

    async edit(item: AutomatedEmail) {
      await this.$router.push({
        name: 'email-edit',
        params: { emailId: `${item.id}` },
      });
    },

    async remove(item: AutomatedEmail) {
      await this.$confirm(
        this.$i18n.t('validation.confirmation.delete', [item.name]).toString(),
        async () => {
          if (item.id && this.items) {
            this.$alert.hide('remove');
            await EmailUtils.api.remove(item.id);
            this.$toast.push({
              type: 'success',
              text: this.$languageobj('validation.success.delete', {
                values: [item.name],
              }),
            });
            const index = this.items.findIndex((val) => val.id === item.id);
            if (index >= 0) {
              this.items.splice(index, 1);
            }
          }
        }
      );
    },

    async send(item: AutomatedEmail) {
      (this.$refs.send as any).open(item);
    },
  },
});
